var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("MLGI-03-01-03-03")))])
      ]),
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _vm._m(5),
            _vm._m(6),
            _vm._m(7),
            _vm._m(8),
            _vm._m(9),
            _c("div", { staticClass: "wrap_cont type2" }, [
              _vm._m(10),
              _c("p", [
                _vm._v(
                  "당행은 다음 각 호와 같이 안전성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다."
                )
              ]),
              _vm._m(11),
              _vm._m(12),
              _vm._m(13),
              _c("dl", { staticClass: "explain" }, [
                _c("dt", [_vm._v("개인정보 취급 직원의 최소화")]),
                _c("dd", [
                  _vm._v(
                    "개인정보를 취급하는 직원을 지정하고 관련 담당자에 최소한의 개인정보를 제공하고 있습니다."
                  )
                ]),
                _c(
                  "dd",
                  [
                    _vm._v(
                      " 보안을 강화하기 위해서 고객의 인터넷 브라우저가 당행 웹사이트의 암호화 조건을 지원할 수 있는지 적합한 단계의 확인이 필요합니다. 당행이 추천하는 인터넷 브라우저의 더 많은 정보는 "
                    ),
                    _c(
                      "router-link",
                      {
                        staticStyle: { "text-decoration": "underline" },
                        attrs: { to: { name: "kbBankingService" } }
                      },
                      [_vm._v("이곳")]
                    ),
                    _vm._v(
                      "을 클릭하면 살펴 보실 수 있습니다. 당행의 웹사이트는 고객이나 당행의 특별한 요청 외에 고객의 개인정보를 수집하지 않습니다. "
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._m(14),
            _vm._m(15),
            _vm._m(16),
            _vm._m(17),
            _vm._m(18),
            _c("br"),
            _c("br"),
            _c("br")
          ]
        : _vm._e(),
      _vm.lang == _vm.$config.LANG_ENG
        ? [
            _vm._m(19),
            _vm._m(20),
            _vm._m(21),
            _vm._m(22),
            _vm._m(23),
            _vm._m(24),
            _vm._m(25),
            _vm._m(26),
            _vm._m(27),
            _vm._m(28),
            _c("div", { staticClass: "wrap_cont type2" }, [
              _vm._m(29),
              _c("p", [
                _vm._v(
                  "KB takes technical and administrative measures to keep your personal information safe"
                )
              ]),
              _vm._m(30),
              _vm._m(31),
              _vm._m(32),
              _c("dl", { staticClass: "explain" }, [
                _c("dt", [_vm._v("Minimize personal information handlers")]),
                _c("dd", [
                  _vm._v(
                    "Handlers of personal information shall be designated and be exclusively provided with minimum personal information."
                  )
                ]),
                _c(
                  "dd",
                  [
                    _vm._v(
                      " To ensure full security you will need to take appropriate steps to ensure that your Internet browser is capable of supporting our website's encryption requirements. More information on the Internet browsers we recommend can be found "
                    ),
                    _c(
                      "router-link",
                      {
                        staticStyle: { "text-decoration": "underline" },
                        attrs: { to: { name: "kbBankingService" } }
                      },
                      [_vm._v("here")]
                    ),
                    _vm._v(
                      ". Our website does not collect personal identifying information about you except where specifically requested by you or us. "
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._m(33),
            _vm._m(34),
            _vm._m(35),
            _vm._m(36),
            _vm._m(37),
            _c("br"),
            _c("br"),
            _c("br")
          ]
        : _vm.lang == _vm.$config.LANG_CAM
        ? [
            _vm._m(38),
            _vm._m(39),
            _vm._m(40),
            _vm._m(41),
            _vm._m(42),
            _vm._m(43),
            _vm._m(44),
            _vm._m(45),
            _vm._m(46),
            _vm._m(47),
            _c("div", { staticClass: "wrap_cont type2" }, [
              _vm._m(48),
              _vm._m(49),
              _vm._m(50),
              _vm._m(51),
              _c("dl", { staticClass: "explain" }, [
                _c("dt", [
                  _vm._v(
                    "កំណត់ចំនួនអ្នកកាន់ពត៌មានឯកជនអប្បបរមានិងការបណ្តុះបណ្តាល"
                  )
                ]),
                _c("dd", [
                  _vm._v(
                    "អ្នកកាន់ពត៌មានឯកជន ត្រូវបានកំណត់អោយផ្តល់នូវពត៌មានឯកជនក្នុងកំរិតអប្បរមា ។"
                  )
                ]),
                _c(
                  "dd",
                  [
                    _vm._v(" " + _vm._s(_vm.$t("Q003-078")) + " "),
                    _c(
                      "router-link",
                      {
                        staticStyle: { "text-decoration": "underline" },
                        attrs: { to: { name: "kbBankingService" } }
                      },
                      [_vm._v(_vm._s(_vm.$t("Q003-092")))]
                    ),
                    _vm._v(" " + _vm._s(_vm.$t("Q003-093")) + " ")
                  ],
                  1
                )
              ]),
              _c("br"),
              _c("p", [
                _vm._v(
                  "ដើម្បីធានាសុវត្ថិភាពពេញលេញ លោកអ្នកត្រូវតែអនុវត្តតាមដំណាក់កាលអោយបានត្រឹមត្រូវ និងត្រូវ ប្រាកដថា Browser អ៊ិនធើណេតរបស់លោកអ្នក មានសមត្ថភាពគ្រប់គ្រាន់តំរូវដោយប្រព័ន្ធលាក់ទុក របស់គេហទំព័រ បាន ។ ពត៌មានបន្ថែមពី Browswer របស់អ៊ិនធើណេត ដែលយើងបានណែនាំ លោក អ្នក អាចរកបាននៅទីនេះ ។ គេហទំព័ររបស់យើង មិនប្រមូលពត៌មានអត្តសញ្ញាណឯកជន របស់ អតិថិជនទេ លើកលែងតែមានសំណើ ពីអតិថិជន រឺដោយធនាគារផ្ទាល់ ។"
                )
              ])
            ]),
            _vm._m(52),
            _vm._m(53),
            _vm._m(54),
            _vm._m(55),
            _vm._m(56),
            _c("br"),
            _c("br"),
            _c("br")
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cont_info type1" }, [
      _c("p", [
        _vm._v(
          'KB캄보디아은행(“당행")은 고객의 개인정보와 재무정보 보호를 중요하게 여기고 있습니다. 당행은 금융 서비스를 제공하는 기관으로서 당행의 상품과 서비스를 제공할 때에 고객의 개인정보를 취득해야 합니다. 이 정보가 고객의 기밀하고 중요한 정보이기 때문에 고객은 당행이 어떻게 고객의 정보를 처리하는지 알고 있어야 합니다.'
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("개인정보의 처리 목적")])
      ]),
      _c("p", [
        _vm._v(
          " 당행은 개인정보의 중요성을 인지하고 있으며 인터넷환경에서 개인정보를 보호하기 위하여 노력합니다. "
        ),
        _c("br"),
        _vm._v("당행은 개인정보를 다음 각 호의 목적을 위해 처리합니다. ")
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", { staticClass: "must" }, [_vm._v("금융거래 관계 관련")]),
        _c("dd", [
          _vm._v(
            "금융거래와 관련하여 신용조회회사 또는 신용정보집중기관에 대한 개인신용정보의 조회, 금융거래 관계의 설정 여부의 판단, 금융거래 관계의 설정·유지·이행·관리, 금융사고 조사, 분쟁 해결, 민원 처리 및 법령상 의무이행 등의 목적으로 개인정보를 처리합니다."
          )
        ]),
        _c("dd", { staticClass: "must" }, [
          _vm._v(
            "금융거래라 함은 은행업무(여신, 수신, 외국환 등)와 관련된 거래를 의미합니다."
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("온라인 거래 관련 목적")]),
        _c("dd", [
          _vm._v(
            "접속빈도 파악, 회원의 서비스 이용에 대한 통계, 전자금융거래의 내용 추적 및 검색, 보안정책 수립용 통계 자료로 활용 등을 목적으로 개인정보를 처리합니다."
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("기타 목적")]),
        _c("dd", [
          _vm._v(" - 회원 가입 및 관리 "),
          _c("br"),
          _vm._v("- 상품 및 서비스 홍보 및 판매 권유 "),
          _c("br"),
          _vm._v("- 신규 서비스 개발 "),
          _c("br"),
          _vm._v("- 맞춤 서비스 제공 "),
          _c("br"),
          _vm._v("- 경품지급, 사은행사 등 고객의 편의 및 참여기회 제공 "),
          _c("br"),
          _vm._v("- 직원채용 ")
        ])
      ]),
      _c("p", [
        _vm._v(
          "당행의 위에 언급한 개인정보처리목적을 변경할 필요가 있는 경우, 고객으로부터 사전동의를 구할 것입니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보의 처리 및 보유 기간")
        ])
      ]),
      _c("p", [
        _vm._v(
          "금융거래와 관련한 개인(신용)정보는 수집·이용에 관한 동의일로부터 금융거래 종료일까지 위 이용목적을 위하여 보유·이용됩니다. 단, 금융거래 종료일 이후에는 금융사고 조사, 분쟁 해결, 민원처리, 법령상 의무이행 및 당행의 리스크 관리업무만을 위하여 보유·이용됩니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "개인(신용)정보의 조회를 목적으로 수집된 개인(신용)정보는 수집·이용에 대한 동의일로부터 고객에 대한 개인(신용)정보 제공·조회 동의의 효력 기간까지 보유·이용됩니다. 단, 개인(신용)정보 제공·조회 동의의 효력 기간 종료 후에는 금융사고 조사, 분쟁 해결, 민원처리 및 법령상 의무이행만을 위하여 보유·이용됩니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "상품 및 서비스 홍보 및 판매 권유 등과 관련한 개인(신용)정보는 수집·이용에 관한 동의일로부터 동의 철회 일까지 보유·이용됩니다. 단, 동의 철회일 후에는 [개인정보의 처리목적]과 관련된 사고 조사, 분쟁 해결, 민원처리, 법령상 의무이행만을 위하여 보유·이용됩니다. 또한 개인(신용)정보를 보유하고 있는 기간 동안에는 당행으로부터 상품 및 서비스 홍보 관련으로 연락을 받으실 수 있습니다. 만일 상품 및 서비스 홍보 관련 연락을 원치 않으실 경우, KB 캄보디아 은행으로 이메일 또는 전화(+855-23-999-300)를 주시기 바랍니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보 수집 출처 등 고지")
        ])
      ]),
      _c("p", [
        _vm._v(
          "당행은 정보주체 이외로부터 수집한 개인정보를 처리하는 때에는 정당한 사유가 없는 한 정보주체의 요구가 있은 날로부터 3영업일 이내에 수집 출처, 처리 목적, 개인정보 처리의 정지를 요구할 권리가 있다는 사실을 정보주체에게 알립니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "정보주체의 요구를 거부하는 경우에는, 정당한 사유가 없는 한 정보주체의 요구가 있은 날로부터 3영업일 이내에 그 거부의 근거와 사유를 정보주체에게 알립니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("개인정보의 제3자 제공")])
      ]),
      _c("p", [
        _vm._v(
          "당행은 원칙적으로 고객의 개인정보를 [개인정보의 처리목적]에서 명시한 목적 범위 내에서 처리하며, 고객의 사전 동의 없이는 본래의 범위를 초과하여 처리하거나 제3자에게 제공하지 않습니다. 단, 다음의 각 호의 경우에는 고객 또는 제3자의 이익을 부당하게 침해할 우려가 있을 때를 제외하고는 개인정보를 목적 외의 용도로 이용하거나 이를 제3자에게 제공할 수 있습니다."
        )
      ]),
      _c("br"),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [_vm._v("고객이 사전에 제3자 제공 및 공개에 동의한 경우")]),
        _c("li", [_vm._v("다른 법률에 특별한 규정이 있는 경우")]),
        _c("li", [
          _vm._v(
            "고객 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 고객 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우"
          )
        ]),
        _c("li", [
          _vm._v(
            "통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를 제공하는 경우"
          )
        ]),
        _c("li", [
          _vm._v(
            'KB캄보디아은행의 모회사인 “KB국민은행"에서 위 [개인정보 처리목적]에서 명시한 목적 범위 내에서 이용하기 위하여 요청하는 경우'
          )
        ])
      ]),
      _c("br"),
      _c("dd", [
        _vm._v(
          "개인(신용)정보는 제공된 날로부터 동의 철회 시 또는 제공된 목적을 달성할 때까지 보유·이용됩니다. 동의 철회 또는 제공된 목적 달성 후에는 위에 기재된 이용목적과 관련된 금융사고 조사, 분쟁해결, 민원처리, 법령상 의무이행을 위하여 필요한 범위 내에서만 보유·이용됩니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("개인정보처리 위탁")])
      ]),
      _c("p", [
        _vm._v(
          "개인정보 처리 위탁계약 시, 당행은 위탁업체가 개인정보 보호 및 개인정보의 제3자 제공 관련 법령을 준수하고 본 개인정보 보호정책을 준수함을 보장하며, 당해 계약내용을 서면 또는 전자 보관하고 있습니다. 업체 선정 또는 변경 시 공지사항을 통해 게시하거나 당행 개인정보보호정책을 수정하여 공지하겠습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("고객의 권리 · 의무 및 그 행사방법")
        ])
      ]),
      _c("p", [
        _vm._v(
          "고객은 당행이 처리하는 자신 및 18세 미만 아동(법정대리인만 해당)의 개인정보의 열람을 요구할 수 있습니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "자신의 개인정보를 열람한 고객은 사실과 다르거나 확인할 수 없는 개인정보에 대하여 당행에 정정 또는 삭제를 요구할 수 있습니다. 다만, 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다."
        )
      ]),
      _c("p", [
        _vm._v(
          " 고객은 당행에 대하여 자신의 개인정보 처리의 정지를 요구할 수 있습니다. 다만 다음 각 호의 어느 하나에 해당하는 경우에는 당행은 해당 사유를 고객에게 알리고, 처리정지 요구를 거절할 수 있습니다. "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우"
          )
        ]),
        _c("li", [
          _vm._v(
            "다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우"
          )
        ]),
        _c("li", [
          _vm._v(
            "개인정보를 처리하지 아니하면 고객과 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 고객이 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("처리하는 개인정보의 항목")
        ])
      ]),
      _c("p", [
        _vm._v(
          "당행은 금융거래의 설정·유지·이행·관리 및 상품서비스의 제공을 위한 필수정보 및 선택정보를 다음 각 호와 같이 수집하고 있습니다."
        )
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("필수적 정보")]),
        _c("dd", [
          _vm._v(
            " - 개인식별정보: 성명, 실명확인번호 등 고유식별정보, 국적, 주소 · 전자우편 주소 · 전화번호 등 연락처 "
          ),
          _c("br"),
          _vm._v(
            "- 금융거래정보: 상품종류, 거래조건(이자율, 만기, 담보 등), 거래일시, 금액 등 거래 설정 및 내역 정보 "
          ),
          _c("br"),
          _vm._v(
            "- 기타 금융거래의 설정 · 유지 · 이행 · 관리를 위한 상담 등을 통해 생성되는 정보 "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("선택적 정보")]),
        _c("dd", [
          _vm._v(
            " - 개인식별정보 외에 거래신청서에 기재된 정보 또는 고객이 제공한 정보 "
          ),
          _c("br"),
          _vm._v("- 주거 및 가족사항, 거주기간, 세대구성, 결혼여부 등 ")
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("인터넷뱅킹 관련 수집 정보")]),
        _c("dd", [
          _vm._v(
            " - 인터넷뱅킹 거래의 내용 추적 및 검색 : 고객 아이디, 접속 일시, IP Address, HDD Serial, MAC Address 등 "
          ),
          _c("br"),
          _vm._v(
            "- 보안정책 수립용 통계 자료 : 개인방화벽 설정, 운영체제 종류, 운영체제 주요 보안패치 여부, 방화벽 설정, 원격접속 설정, 브라우저 버전, 키보드 타입 등 "
          ),
          _c("br"),
          _vm._v(
            "* 당행은 고객의 사생활을 침해할 우려가 있는 민감한 정보에 대해서는 원칙적으로 수집하지 않으며, 필요한 경우 고객의 별도 동의를 받아 수집하고 동의 목적을 위해서만 제한적으로 이용합니다. "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("수집방법")]),
        _c("dd", [
          _vm._v(" - 당행 영업점에 내방한 고객으로부터 직접 수집 "),
          _c("br"),
          _vm._v(
            "- 홈페이지, 서면양식, 팩스, 전화, 상담 게시판, 이메일, 응모내역, 배송요청 "
          ),
          _c("br"),
          _vm._v("- 생성정보 수집 툴을 통한 수집 ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보 자동 수집 장치의 설치, 운영 및 거부 관련사항")
        ])
      ]),
      _c("p", [
        _vm._v(
          "당행은 고객께서 홈페이지에 접속하신 상태에서 이용자 인증을 위하여 '쿠키(Cookie)'를 이용하고 있습니다. 쿠키는 이용자 사이트에 대한 기본 설정정보를 보관하기 위해 해당 웹사이트가 이용자의 컴퓨터 브라우저에 전송하는 소량의 정보입니다. 이용자가 웹사이트에 연결되어 있을 때, 추가로 ID 등을 입력 할 필요 없이 서비스 제공자의 컴퓨터가 이용자의 부가정보를 찾아내어 연결에 관계하여 이용자의 브라우저상의 쿠키내용을 읽어내고 서비스를 제공하는 것입니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "쿠키 이용에 대한 선택권은 고객이 가지고 있습니다. 고객님의 웹 브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부하는 등의 옵션을 선택하실 수 있습니다. 단, 고객이 쿠키의 저장을 거부하는 옵션을 선택하시는 경우에는 서비스 이용에 불편이 야기될 수 있습니다. 또한, 당행의 웹사이트는 다른 사이트로 연결하는 하이퍼링크를 포함하고 있습니다. 당행은 연결된 사이트의 개인정보정책 및 사이트에서 제공하는 정보의 안정성에 대하여 책임을 지지 않습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("개인정보의 파기")])
      ]),
      _c("p", [
        _vm._v(
          " 당행은 개인정보의 보유기간이 경과된 경우, 개인정보의 처리목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에 다음 각 호의 사유가 없는 한 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 5영업일 이내에 그 개인정보를 파기합니다. "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "신용정보집중기관 또는 신용조회회사가 신용정보의 집중관리·활용 또는 개인의 신용도 등을 평가하기 위한 목적으로 개인신용정보를 보유하는 경우(보유기간에 한함)"
          )
        ]),
        _c("li", [
          _vm._v(
            "신용정보회사 등이 민·형사상의 책임 또는 시효가 지속되거나 분쟁의 입증자료로서 개인신용정보를 보유하는 경우"
          )
        ]),
        _c("li", [_vm._v("법령에 따라 보존하여야 하는 경우")]),
        _c("li", [_vm._v("기타 이와 유사한 정당한 사유가 있는 경우")])
      ]),
      _c("p", [
        _c("br"),
        _vm._v(
          "개인정보가 기록된 출력물, 서면 등은 파쇄 또는 소각의 방법으로 파기하고, 전자적 파일형태의 개인정보는 복원이 불가능한 방법으로 영구 삭제하는 방법으로 파기합니다. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_title" }, [
      _c("h2", { staticClass: "h_title2" }, [
        _vm._v("개인정보의 안전성 확보 조치")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("개인정보의 암호화")]),
      _c("dd", [
        _vm._v(
          "고객의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("해킹 등에 대비한 기술적 대책")]),
      _c("dd", [
        _vm._v(
          "당행은 키보드 입력 값에 대한 해킹방지를 위한 가상키보드를 운영하고, 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치를 권유하여 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하는 등 기술적·물리적으로 감시 및 차단하고 있습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("개인정보처리시스템 접근 제한")]),
      _c("dd", [
        _vm._v(
          "개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보 처리방침의 변경")
        ])
      ]),
      _c("p", [
        _vm._v(
          "당행이 개인정보 처리방침을 변경하는 경우에는 변경 및 시행의 시기, 변경된 내용을 지속적으로 공개하며, 변경된 내용은 고객이 쉽게 확인할 수 있도록 변경 전·후를 비교하여 공개합니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보의 보호를 위해 알아야 할 기타사항")
        ])
      ]),
      _c("p", [
        _vm._v(
          "귀하가 온라인 게시판이나 이메일, 메신저에서 제공한 정보는 타인에 의해 수집되거나 사용될 수 있음을 언제나 명심하시기 바랍니다. 예를 들어 원하지 않는 메시지를 받게 될 수도 있습니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "귀하는 이용자 ID, 이용자 암호 또는 보안매체(일회용비밀번호생성기, OTP)를 철저하게 관리할 책임이 있으며, 인터넷뱅킹에 접속할 시 적절한 주의가 필요합니다."
        )
      ]),
      _c("p", [
        _vm._v(
          "당행은 귀하가 개인정보를 부주의하게 이용하여 다른 곳에서 생긴 사고에 대해서는 책임을 지지 않습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("권익침해 구제방법")])
      ]),
      _c("p", [
        _vm._v(
          "고객은 개인정보침해로 인한 신고나 상담이 필요하신 경우 아래 기관에 문의하시기 바랍니다."
        )
      ]),
      _c("p", [
        _c("strong", { staticClass: "fc_point1" }, [
          _vm._v("KB 캄보디아 은행(+855-23-999-300~308)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("개인정보 보호책임자 및 개인정보 관리책임자")
        ])
      ]),
      _c("dl", { staticClass: "addr" }, [
        _c("dt", [
          _vm._v("당행의 개인정보 보호 및 관리 책임자는 다음과 같습니다.")
        ]),
        _c("br"),
        _c("dt", [
          _c("strong", { staticClass: "fc_point1" }, [
            _vm._v("KB 캄보디아 은행장 김현종")
          ])
        ]),
        _c("dd", [
          _c("span", [
            _vm._v(
              "No 55, Street 214, Sangkat Boeung Raing, Khan Daun Penh, Phnom Penh, Cambodia."
            )
          ])
        ]),
        _c("dd", [_vm._v("전화 : +855-23-999-300~308")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("p", [_vm._v("개인정보처리방침 버전번호 : Ver 2.0")]),
      _c("p", [_vm._v("개인정보처리방침 시행일자 : 2020.06.30")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cont_info type1" }, [
      _c("p", [
        _vm._v(
          'KOOKMIN Bank Cambodia PLC. ("KB") recognizes the importance of safeguarding your personal and financial information. As an institution offering financial services, KB needs to obtain personal information about you in the course of providing our products and services. Because this information is confidential and important to you, we think it\'s important you know how we treat your information.'
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("How We Use Personal Information")
        ])
      ]),
      _c("p", [
        _vm._v(" KB assures you that: "),
        _c("br"),
        _vm._v(
          "We understand your personal information is important and we are committed to protecting your privacy in the online environment. "
        )
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("We only use your personal information:")]),
        _c("dt", { staticClass: "must" }, [
          _vm._v("For the purpose of processing Financial Transactions")
        ]),
        _c("dd", [
          _vm._v(
            "KB uses personal information for the purpose of making inquires on personal credit information through credit bureaus or credit information centralization agencies pertaining to financial transactions, making a decision on building a financial transaction relationship establishing/keeping/executing/managing a financial transaction relationship, investigating financial incidents, resolving disputes, addressing customer complaints or fulfilling statutory obligations."
          )
        ]),
        _c("dd", { staticClass: "must" }, [
          _vm._v(
            "Financial Transaction defines all relevant banking transaction (including loan, deposit, foreign exchange etc.)."
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [
          _vm._v("For the purpose of dealing with Online Transactions")
        ]),
        _c("dd", [
          _vm._v(
            "KB uses personal information for the purpose of identifying frequency of customer visits to our website, getting statistic concerning service utilization, tracing and searching details of electronic financial transactions, or referring to statistics to develop security measures."
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("For Others")]),
        _c("dd", [
          _vm._v(" - Sign up and Manage a membership "),
          _c("br"),
          _vm._v("- Help us to provide our products and services "),
          _c("br"),
          _vm._v("- Improve our service "),
          _c("br"),
          _vm._v("- Inform you of products you have indicated an interest in "),
          _c("br"),
          _vm._v(
            "- Provide opportunities for engagement by giving free gifts or running customer promotion "
          ),
          _c("br"),
          _vm._v("- Career ")
        ])
      ]),
      _c("p", [
        _vm._v(
          "When we need to change purpose of Information we obtain, we will ask you to seek the prior consent."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Period of Processing And Retention of Personal Information")
        ])
      ]),
      _c("p", [
        _vm._v(
          "Personal Information with respect to financial transitions shall be retained used for the period from the data of consent to information collection/utilization till the date of termination of financial transactions for above-stated purposes; provided that such information shall be kept and used only for investigating financial incidents, resolving disputes, addressing customer complaints or fulfilling legal obligations or performing risk management operations of KB after the date of termination of such financial transactions."
        )
      ]),
      _c("p", [
        _vm._v(
          "Personal information gleaned for the purpose of personal information inquiry shall be kept and used for the period from the day you agree to the collection / utilization of personal information to the end date of such consent; provided that such information shall be kept and used only for investigating financial incidents, resolving disputes, addressing customer complaints or fulfilling statutory obligations on or after the end date of your consent to providing personal information and authorizing inquires to be made thereon."
        )
      ]),
      _c("p", [
        _vm._v(
          "Personal Information pertaining to promotion or sale of products and services shall be used for the period from the date of consent to the collection and use of such information to the date of withdrawal of the consent; provide, that such information shall be retained and used only for investigating incidents, resolving disputes, addressing customer complaints or fulfilling statutory obligations with respect to above-stated purposes on or after the day when the consent is withdrawn. Also, we may contact you to inform you of services and products available from KB during the retention period. If you do not wish to receive these offers please email us or call us on +855-23-999-300"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Disclosure of Personal Information")
        ])
      ]),
      _c("p", [
        _vm._v(
          "In case of processing personal information gathered from sources other than the subject of the information, KB shall notify the subject of their rights to demand that KB disclose sources and processing purpose of the information or suspend information processing within three(3) business days from the demand, unless KB has valid reasons to do otherwise Also, in case KB rejects demand of an information subject, KB, without justifiable causes to the contrary, shall inform the subject of the ground and reason for the rejection within three (3) business days from the demand"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Information We Provide to a 3rd party")
        ])
      ]),
      _c("p", [
        _vm._v(
          "KB uses your personal information within the scope of purposes determined in above-stated herein and, without your prior consent, shall not exceed the prescribed scope or provide such information to a 3rd party; except for the following cases where personal information may be used for purposes beyond the original scope or furnished to a 3rd party unless such act may unreasonably prejudice interests of you or the third party:"
        )
      ]),
      _c("br"),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "You have given prior consent to provision or disclosure of personal information to a third party"
          )
        ]),
        _c("li", [
          _vm._v(
            "There are special regulations of other laws permitting or requiring such act"
          )
        ]),
        _c("li", [
          _vm._v(
            "It is clearly deemed necessary for urgent protection of life, body or property of you or a third party in cases where you or your legal representative is not in a state to express yourselves or you are not reachable for prior consent for reasons including but not limited to unknown address; or"
          )
        ]),
        _c("li", [
          _vm._v(
            "Personal information is provided in a format which makes it impossible to identify individuals in cases where such information is required for statistic or academic research purposes."
          )
        ]),
        _c("li", [
          _vm._v(
            "KB Kookmin Bank, parent company of Kookmin Bank Cambodia PLC, requests to use personal information for above purpose on [How We Use Personal Information]."
          )
        ])
      ]),
      _c("br"),
      _c("dd", [
        _vm._v(
          "Personal information shall be retained and used for the period from the date of provision until the date of withdrawal of consent or until when the purpose of such provision is fulfilled. On or after the day when such consent is withdrawn or the purpose of provision of personal information is met, such information shall be retained and used only within the scope required for investigating financial incidents, resolving disputes, addressing customer complaints or performing statutory obligations with respect to the above-stated purposes."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Outsourcing of Personal Information Processing")
        ])
      ]),
      _c("p", [
        _vm._v(
          "In contraction outside vendors, KB clarifies their contractual obligations to abide by laws and regulations governing personal information protections, prohibition of personal information provision to a third party and their liability in the contracts that are documented and kept both in writing and electronically by KB. KB will disclose new contract or any change to its vendors either by posting them on the announcements board of our website or by amending and modifying KB KOOKMIN Privacy Policy."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("RIGHTS & Obligation, And Ways to Enforce Them")
        ])
      ]),
      _c("p", [
        _vm._v(
          "You are entitled to demand access to personal information handled by KB pertaining to you or children aged under 18(only if you are their duly authorized legal guardian)."
        )
      ]),
      _c("p", [
        _vm._v(
          "You may demand that KB correct or delete personal information you have read in case the information differs from the truth or is not verifiable unless such information shall be collected, as regulated in other laws or regulations."
        )
      ]),
      _c("p", [
        _vm._v(
          " You may demand that KB suspend processing your personal information; provided that KB may reject such demand for suspension of information processing by giving you the reason of rejection if: "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "Either there are special regulations in laws or KB cannot but process your information to fulfill our obligations that are required by laws and regulations"
          )
        ]),
        _c("li", [
          _vm._v(
            "Suspension of information processing ay harm life or body of another person or unreasonably prejudice property or other interests of another person or"
          )
        ]),
        _c("li", [
          _vm._v(
            "Our failure to process personal information interferes with our performance of contact with you including but not limited to failure to provide contracted services to you in cases where you have not explicitly expressed your intention to terminate the contract."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Items of Personal Information Required")
        ])
      ]),
      _c("p", [
        _vm._v(
          "KB collects necessary and optional information as follows which is required for establishing·keeping·executing·managing financial transactions and offering products and services."
        )
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("Necessary Information")]),
        _c("dd", [
          _vm._v(
            " - Personal identifier: unique identifiers including name, personal identification number, nationality, contact information such as address, email and phone number, etc. "
          ),
          _c("br"),
          _vm._v(
            "- Information on financial transaction: product type, transaction terms(interest rate, maturity, security, etc), date and time of transaction, transaction amount, etc. "
          ),
          _c("br"),
          _vm._v(
            "- Any other information generated from consulting for establishing·keeping·executing and managing financial transactions. "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("Optional Information")]),
        _c("dd", [
          _vm._v(
            " - Information stated on transaction application forms other than personal identifiers, or any other information given by you. "
          ),
          _c("br"),
          _vm._v(
            "- Housing, family status, length of residence, household members, marital status, etc "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("Information collected for Internet Banking")]),
        _c("dd", [
          _vm._v(
            " - Tracking Internet Banking transactions: your user ID, date and time of log-in, IP address, HDD serial, MAC address, and etc. "
          ),
          _c("br"),
          _vm._v(
            "- Statistical data to organize our Security Policy: personal firewall setting, OS type, security patches, firewall setting, remote access setting, browser version, keyboard type, etc. "
          ),
          _c("br"),
          _vm._v(
            "* KB basically does not collect any sensitive personal information that could invade your privacy. Only when it is essential, we collect and use it only with your additional consent. "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("Collection Methods")]),
        _c("dd", [
          _vm._v(" - Directly from customers who visit our branches "),
          _c("br"),
          _vm._v(
            "- Website, written forms, fax, phone, Q&A message board, email, entry for promotional event, request for delivery "
          ),
          _c("br"),
          _vm._v("- Collection tool for information populated ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("Use of Cookie")])
      ]),
      _c("p", [
        _vm._v(
          'KB does use technology in order to offer you the most convenient, secure and relevant services. An example of the technology that KB uses is a "cookie". A cookie is an element of data that the website can send to your browser, which may then store it on your system. KB presently uses cookies to maintain our security requirements during your use of our website. When a user is connected with the website, the service provider’s computer can read the contents of the Cookie in the user’s browser and provide services by finding the user’s additional information in its own computer without additional input of ID etc., concerning the connection.'
        )
      ]),
      _c("p", [
        _vm._v(
          "It is also important that you know that to transact with KB you do not necessarily need to enable your browser to accept the cookies. You may be able to get your browser to notify you when you receive a cookie giving you the chance to decide whether or not to accept it. There is also a lot of information on the Internet in respect of cookies. Please note some information and/or services may not be available if you disable your browser not to accept cookies. Please also note that while the KB website hyperlinks to various other websites, KB is not responsible for the privacy practice of those websites and/or the reliability of the information published on those websites."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Destruction of Personal Information")
        ])
      ]),
      _c("p", [
        _vm._v(
          " In case the retention period of personal information expires, KB shall destroy personal information in 5 business days when such information becomes of no use for reasons such as expiration of retention period, fulfillment of purpose of personal information handling, discontinuation of relevant services or closure of business, etc. unless: "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "Credit information centralization agencies or credit bureaus retain personal credit information(only for the allowed retention period) for the purpose of centralized management utilization of credit information or assessment of personal creditworthiness."
          )
        ]),
        _c("li", [
          _vm._v(
            "Credit bureaus, etc. retain personal credit information for the period of effectiveness of civil, criminal obligations or for the period under a statute of limitations or hold personal credit information as evidence to resolve disputes."
          )
        ]),
        _c("li", [
          _vm._v(
            "In case KB is obliged to preserve personal information in accordance with the law."
          )
        ]),
        _c("li", [_vm._v("There are any other reasonable causes similar.")])
      ]),
      _c("p", [
        _c("br"),
        _vm._v(
          "Documents and prints that contain personal information should be disintegrated or destroyed by fire and electronic formed personal information should be eliminated permanently so that restoration is impossible. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_title" }, [
      _c("h2", { staticClass: "h_title2" }, [
        _vm._v("How we Protect Your Privacy")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("Encryption of personal information")]),
      _c("dd", [
        _vm._v(
          "Your personal information and passwords are accessible only by you because it is stored and managed through encryption. Files and transmission data containing important data are protected via separate security measures including encryption or file locking."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("Technical Measures against Hacking")]),
      _c("dd", [
        _vm._v(
          "Our virtual keyboard keeps the value you input safe from leak. And to prevent any leakage or destruction of personal information triggered by hacking or computer viruses, KB recommends that you install security programs and updated, monitored on a periodic basis while placing a system in an access restricted area and conducting technical/physical monitoring and access block from outside."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("Restricted Access Personal Data-handling System")]),
      _c("dd", [
        _vm._v(
          "KB takes measures required for restricting access to personal information by authorizing, modifying or terminating access to database system which processes personal information."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Modification of the Privacy Policy")
        ])
      ]),
      _c("p", [
        _vm._v(
          "In case of any changes to the Privacy Policy, the timing of amendment and effectuation as well as details of changes shall be constantly disclosed. Comparison of before and after changes shall be disclosed to help you better grasp details of the changes."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v(
            "Things You Need to Know for Protection of Personal Information"
          )
        ])
      ]),
      _c("p", [
        _vm._v(
          "Please keep in mind that the information you provide online bulletin board, e-mail or messenger can be collected or used by others. You may get messages you do not want in such a case."
        )
      ]),
      _c("p", [
        _vm._v(
          "You are responsible for keeping your ID, User Password and OTP (One Time Password) private and confidential, and you should take care when you access Internet Banking."
        )
      ]),
      _c("p", [
        _vm._v(
          "KB is not responsible for an accident that happens by your negligence or misconduct in taking care of personal information."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Remedy for Infringement of Rights")
        ])
      ]),
      _c("p", [
        _vm._v(
          "Please contact our Customer Service Center or the organizations below for more information or assistance"
        )
      ]),
      _c("p", [
        _c("strong", { staticClass: "fc_point1" }, [
          _vm._v("Kookmin Bank Cambodia PLC. (+855-23-999-300~308)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("Personal Information Protection Manager")
        ])
      ]),
      _c("dl", { staticClass: "addr" }, [
        _c("dt", [
          _c("strong", { staticClass: "fc_point1" }, [
            _vm._v("Kookmin Bank Cambodia PLC. President & CEO Kim Hyeun Jong")
          ])
        ]),
        _c("dd", [
          _c("span", [
            _vm._v(
              "No 55, Street 214, Sangkat Boeung Raing, Khan Daun Penh, Phnom Penh, Cambodia."
            )
          ])
        ]),
        _c("dd", [_vm._v("Tel : +855-23-999-300~308")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("p", [
        _vm._v("KOOKMIN BANK Cambodia PLC Privacy Policy Version: Ver 2.0")
      ]),
      _c("p", [_vm._v("Effective Date for Privacy Policy: 30.06.2020")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cont_info type1" }, [
      _c("p", [
        _vm._v(
          "ធនាគារគូកមីនកម្ពុជា ភីអិលស៊ី (“KBC” ) ទទួលស្គាល់ពីសារ:សំខាន់នៃការរក្សាពត៌មានសំងាត់ ឯកជននិងពត៌មានហិរញ្ញវត្ថុរបស់អតិថិជន ។ ក្នុងនាមជាស្ថាប័នផ្តល់សេវាហិរញ្ញវត្ថុ ធនាគារ គូកមីន ត្រូវការពត៌មានឯកជន ដើម្បីផ្តល់សេវាកម្មដល់អតិថិជន ។ ពត៌មានទាំង នេះត្រូវរក្សាការ សំងាត់ និងមានសារ:សំខាន់សំរាប់អតិថិជន ហេតុនេះហើយ យើងខ្ញុំគិតថា អតិថិជនគួរតែដឹងពី របៀបនៃការប្រើប្រាស់ពត៌មានឯកជនរបស់អតិថិជន ដោយធនាគារគូកមីន ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("របៀបនៃការប្រើប្រាស់ពត៌មានឯកជនរបស់អតិថិជនដោយធនាគារគូកមីន")
        ])
      ]),
      _c("p", [
        _vm._v(" ធនាគារគូកមីនកម្ពុជា ភីអិលស៊ី សូមធានាថា: "),
        _c("br"),
        _vm._v(
          "យើងខ្ញុំទទួលស្គាល់និងយល់ពីសារ:សំខាន់នៃពត៌មានឯកជន និងយើងខ្ញុំសន្យារក្សាពត៌មានឯកជន ដែលប្រើប្រាស់នៅលើប្រព័ន្ធអេឡិចត្រូនិច ។ "
        )
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("ធនាគារប្រើប្រាស់ពត៌មានឯកជន របស់អតិថិជនសំរាប់ :")]),
        _c("dt", { staticClass: "must" }, [
          _vm._v("ធ្វើប្រតិបត្តិការហិរញ្ញវត្ថុ: ធនាគារគូកមីនកម្ពុ")
        ]),
        _c("dd", [
          _vm._v(
            "ប្រើប្រាស់ពត៌មានឯកជនរបស់ អតិថិជន សំរាប់តែគោលបំណងសូររកពត៌មានឥណទានឯកជន តាមរយ: ការិយាល័យ ចែករំលែក ពត៌មានឥណទាន រឺភ្នាក់ងារពត៌មានឥណទានទាក់ទងនឹងប្រតិបត្តិការហិរញ្ញវត្ថុ សំរាប់ធ្វើ ការសំរេចចិត្តធ្វើប្រតិបត្តិការហិរញ្ញវត្ថុ ក៏ដូចជាសំរាប់បង្កើត/រក្សា/ អនុវត្ត/រៀបចំ ប្រតិបត្តិ ការហិរញ្ញវត្ថុដែលពាក់ព័ន្ធ និងស៊ើបអង្កេតឧប្បទ្ទវហេតុ ទាក់ទងនឹងហិរញ្ញុត្ថុ ការដោះ ស្រាយជំលោះ"
          )
        ]),
        _c("dd", { staticClass: "must" }, [
          _vm._v("និងការតវ៉ារបស់អតិថិជន រឺការបំពញកាតព្វកិច្ចតាមច្បាប់ណាមួយ ។")
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("សំរាប់ធ្វើប្រតិបត្តិការOnline : ធនាគារគូកមីនកម្ពុ")]),
        _c("dd", [
          _vm._v(
            "ប្រើប្រាស់ពត៌មានឯកជនរបស់ អតិថិជន សំរាប់កំណត់អត្តសញ្ញាណនៃភាពញឹកញាប់របស់អតិថិជនដែលចូលប្រើប្រាស់ គេហទំព័រ ឬសំរាប់ស្រង់ស្ថិតិដែលទាក់ទងនឹងការប្រើប្រាស់សេវាកម្មធនាគារ ឬស្រាវជ្រាវ ពីពត៌មានលំអិត នៃប្រតិបត្តិការហិរញ្ញវត្ថុអេឡិចត្រូនិច ឬក៏យកពត៌មានយោង ដើម្បីបង្កើត វិធីការពារសុវត្ថិភាព ។"
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("សំរាប់គោលបំណងផ្សេងៗ")]),
        _c("dd", [
          _vm._v(" - សំរាប់ការ Sign Up និងការគ្រប់គ្រងសមាជិកភាព "),
          _c("br"),
          _vm._v("- ជួយធនាគារក្នុងការផ្គល់សេវាកម្មជូនអតិថិជន "),
          _c("br"),
          _vm._v("- ធ្វើអោយសេវាកម្មប្រសើរឡើង "),
          _c("br"),
          _vm._v(
            "- ជួយផ្តល់ពត៌មានដល់អតិថិជនពីសេវាកម្មដែលអតិថិជនមានចំណាប់អារម្មណ៍ "
          ),
          _c("br"),
          _vm._v(
            "- ផ្តល់ពត៌មានពីឪកាសបានកាដូមិនគិតថ្លៃ រឺសំរាប់ធ្វើប្រមូសិនជូនអតិថិជន "
          ),
          _c("br"),
          _vm._v("- ការងារ ")
        ])
      ]),
      _c("p", [
        _vm._v(
          "នៅពេលយើងខ្ញុំ ត្រូវការផ្លាស់ដូរគោលបំណង នៃការប្រើប្រាស់ពត៌មានឯកជនរបស់អតិថិជន ធនាគារ នឹងស្នើសុំការយល់ព្រមពីអតិថិជនជាមុនជានិច្ច ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("រយ:ពេលនៃការប្រើប្រាស់និងការរក្សាទុកនៃពត៌មានឯកជន")
        ])
      ]),
      _c("p", [
        _vm._v(
          "ពត៌មានឯកជនពាក់ព័ន្ធនឹងប្រតិបត្តិការហិរញ្ញវត្ថុ នឹងត្រូវរក្សាទុកដើម្បីប្រើប្រាស់ ចាប់ពីថ្ងៃដែល ទិន្នន័យ ត្រូវបានយល់ព្រមអោយប្រមូលនិងអោយប្រើប្រាស់ រហូតដល់ថ្ងៃបញ្ចប់ នៃប្រតិបត្តិការ ហិរញ្ញវត្ថុដែលមានកំណត់ពីគោលបំណងច្បាស់លាស់។ ម្យ៉ាងទៀត ពត៌មានឯកជនទាំងនោះ ត្រូវ រក្សាទុកនិងប្រើប្រាស់ សំរាប់តែស៊ើបអង្កេតឧប្បទ្ទវហេតុហិរញ្ញវត្ថុ ដំណោះស្រាយជម្លោះនិងការតវ៉ា អតិថិជន រឺសំរាប់បំពេញកាតព្វកិច្ចស្របច្បាប់ រឺសំរាប់ធ្វើប្រតិបត្តិការគ្រប់គ្រងហានិភ័យរបស់ ធនាគារគូកមីន បន្ទាប់ពីមួយថ្ងៃនៃកាលបរិច្ឆេទនៃការបញ្ចប់ប្រតិបត្តិការហិរញ្ញវត្ថុនោះ ។"
        )
      ]),
      _c("p", [
        _vm._v(
          "ពត៌មានឯកជនត្រូវបានប្រមូលមក សំរាប់ការសួររកពត៌មានឯកជន ដែលបានរក្សាទុកនិងប្រើប្រាស់ ក្នុងអំឡុងពេលចាប់ពីថ្ងៃដែលអតិថិជនយល់ព្រមអោយប្រមូល/ប្រើប្រាស់ ដល់ថ្ងៃបញ្ចប់ នៃការយល់ ព្រមឈប់អោយប្រើប្រាស់ ។ ម្យ៉ាងទៀតពត៌មានឯកជនទាំងនោះត្រូវរក្សាទុកនិងប្រើប្រាស់ សំរាប់តែ ស៊ើបអង្កេតឧប្បទ្ទវហេតុហិរញ្ញវត្ថុ ដំណោះស្រាយជម្លោះនិងតវ៉ាអតិថិជន រឺសំរាប់បំពេញ កាតព្វកិច្ច តាមច្បាប់ រឺបន្ទាប់ពីមួយថ្ងៃនៃថ្ងៃបញ្ចប់ការយល់ព្រមផ្តល់ពត៌មានឯកជន និង ការអនុញ្ញាតអោយសួរ រក។"
        )
      ]),
      _c("p", [
        _vm._v(
          "ពត៌មានឯកជនពាក់ព័ន្ធនឹងការប្រម៉ូសិន រឺការលក់បញ្ចុះតំលៃនៃផលិតផល រឺសេវាកម្ម នឹងត្រូវប្រើក្នុង អំឡុងពេលចាប់ពីថ្ងៃ ដែលបានយល់ព្រមប្រមូលនិងអោយប្រើប្រាស់ពត៌មាន រហូតដល់ថ្ងៃរំលត់នៃ កិច្ចសន្យា ហើយពត៌មានទាំងនោះ ត្រូវបានរក្សាទុកនិងប្រើប្រាស់សំរាប់ការស៊ើបអង្កេតឧបទ្ទវហេតុ ការដោះស្រាយជំលោះ និងការតវ៉ារបស់អតិថិជន រឺការបំពេញកាតព្វកិច្ចតាមផ្លូវច្បាប់ ដែលមាន បង្ហាញពីគោលបំណង រឺថ្ងៃបន្ទាប់នៃការរំលត់នៃកិច្ចសន្យា ។ ម្យ៉ាងវិញទៀត ធនាគារយើងខ្ញុំនឹង ទាក់ទងអតិថិជន ដើម្បីជំរាបអំពីសេវាកម្មនិងផលិតផល ដែលផ្តល់ជូនដល់អតិថិជន នៅថ្ងៃអនាគត ។ ប្រសិនបើអតិថិជន មិនចង់អោយពត៌មានទាំងនេះត្រូវបានបង្ហាញ សូមអ៊ីម៊ែល រឺទូរស័ព្ទ មកលេខ +855-23-999-300។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("ការផ្សាយចេញពត៌មានឯកជន")])
      ]),
      _c("p", [
        _vm._v(
          "ក្នុងករណីប្រើប្រាស់ពត៌មានឯកជន ដែលប្រមូលពីប្រភពច្បាស់លាស់ណាមួយ ក្រៅពីកម្មវត្ថុនៃ ការប្រមូលពត៌មាន ធនាគារគូកមីនកម្ពុជា ត្រូវជំរាបជូនពីសិទ្ធិទាមទាររបស់អតិថិជនថា ថា ធនាគារគូកមីនបន្តផ្សាយចេញពីប្រភពពត៌មាន និងធ្វើដំណើរការលើកម្មវត្ថុនៃការប្រមូលពត៌មាន រឺបង្ខាំងមិនអោយប្រើប្រាស់ពត៌មាន តែក្នុងរយ:ពេលបីថ្ងៃ គិតចាប់ពីការទាមទារ ។ បើមិនដូច្នោះ ធនាគារគូកមីន ត្រូវមានហេតុផលត្រឹមត្រូវណាមួយជាក់លាក់ ដើម្បីប្រើប្រាស់ពត៌មានបន្ត ។ លើសពីនេះទៅទៀត ក្នុងករណីធនាគារគូកមីន បដិសេធការទាមទារពត៌មាន ធនាគារ នឹងជំរាបប្រាប់ ពី មូលហេតុនៃការបដិសេធ ក្នុងអំឡុងពេលបីថ្ងៃ ដោយគ្មានហេតុដែលត្រូវកែតំរូវនូវអ្វីដែលផ្ទុយ ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ពត៌មានដែលធនាគារចែករំលែកទៅតតីយជន")
        ])
      ]),
      _c("p", [
        _vm._v(
          "ធនាគារគូកមីន ប្រើប្រាស់ពត៌មានឯកជនរបស់អតិថិជន ដែលមានចែងក្នុគោលបំណង ដោយមិនចាំ បាច់មានការយល់ព្រមពីអតិថិជនជាមុន ប៉ុន្តែមិនលើសពីដែនកំណត់ទុក រឺមិនផ្តល់ពត៌មានឯកជន របស់អតិថិជនទៅតតីយជន លើកលែងតែករណីដូចជា ពត៌មានឯកជន មិនត្រូវបានប្រើប្រាស់ក្នុង កម្មវត្ថុដំបូង រឺផ្តល់ទៅតតីយជន ប្រសិនបើ សកម្មភាពទាំងនោះ រើសអើង នឹងចំណាប់អារម្មណ៍របស់ អតិថិជន រឺតតិយជន ដោយមិនសមហេតុផលណាមួយដូចខាងក្រោម:"
        )
      ]),
      _c("br"),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "អតិថិជនបានយល់ព្រមជាមុន នឹងលក្ខ័ណ្ឌនៃការផ្សាយចេញនៃពត៌មានឯកជន ទៅតតិយជន"
          )
        ]),
        _c("li", [_vm._v("មានគោលការណ៍ពិសេស នៃច្បាប់ដែលអនុញ្ញាតអោយអនុវត្ត")]),
        _c("li", [
          _vm._v(
            "វាចាំបាច់ណាស់ ដើម្បីការការពារជីវិត រាង្គកាយ រឺទ្រព្យសម្បត្តិរបស់អតិថិជន រឺរបស់ តតិយជន ក្នុងករណីដែលអតិថិជន រឺតំណាងស្របច្បាប់របស់អតិថិជន មិនស្ថិតក្នុងប្រទេស ដើម្បីបញ្ជាក់ពីខ្លួនអ្នក រឺមិនអាចត្រូវបានទាក់ទងអតិថិជនបាន ដើម្បីសុំការយល់ព្រមជាមុន ដើម្បីមូលហេតុណាមួយ ព្រោះមិនមានអាស័យដ្ឋានច្បាស់លាស់ ។"
          )
        ]),
        _c("li", [
          _vm._v(
            "ពត៌មានឯកជន ត្រូវបានផ្តល់អោយក្នុងទំរង់ ដែលមិនអាចអោយស្គាល់អតិថិជនណាមួយ បាន ទេ ក្នុងករណី ពត៌មានឯកជនរបស់អតិថិជន ត្រូវផ្តល់អោយក្នុងគោលបំណងស្រាវជ្រាវ រឺធ្វើ ស្ថិតិ ។"
          )
        ]),
        _c("li", [
          _vm._v(
            "ធនាគារគូកមីន ដែលជាធនាគារមេរបស់ធនាគារគូកមីនកម្ពុជា ស្នើអោយប្រើប្រាស់ពត៌មាន ឯកជនរបស់អតិថិជន តែក្នុងគោលបំណងដែលបានកំណត់ទុកក្នុង [ការប្រើប្រាស់ពត៌មាន អតិថិជនរបស់ធនាគារ] ។"
          )
        ])
      ]),
      _c("br"),
      _c("dd", [
        _vm._v(
          "ពត៌មានឯកជនរបស់អតិថិជន នឹងត្រូវរក្សាទុកនិងប្រើប្រាស់ សំរាប់អំឡុងពេលចាប់ពីកាលបរិច្ឆេទ យល់ព្រមក្នុងលក្ខខណ្ឌ រហូតដល់ថ្ងៃរំលត់កិច្ចសន្យា រឺរហូតដល់ពេលដែលគោលបំណង ដែល មានក្នុងលក្ខខណ្ឌត្រូវបានបំពេញ ។ នៅរឺបន្ទាប់ថ្ងៃនៃកិច្ចសន្សាត្រូវបានរំលត់ រឺគោលបំណង នៃ ការផ្តល់ពត៌មានត្រូវបានបំពេញ ពត៌មានទាំងនោះនឹងត្រូវរក្សាទុកនិងប្រើប្រាស់ តែក្នុងដែនដែល តំរូវការស៊ើបអង្កេតលើឧប្បទ្ទវហេតុហិរញ្ញវត្ថុ ដំណោះស្រាយជំលោះ និងការតវ៉ារបស់អតិថិជន រឺការបំពេញកាតព្វកិច្ចស្របច្បាប់ណាមួយ ដែលបានចែងក្នុងគោលបំណងច្បាស់លាស់ ណាមួយ ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ការផ្តល់ពត៌មានឯកជនរបស់អតិថិជនទៅប្រភពខាងក្រៅ")
        ])
      ]),
      _c("p", [
        _vm._v(
          "ក្នុងកិច្ចសន្សាជាមួយអ្នកលក់ ធនាគារគូកមីន ត្រូវបញ្ជាក់អោយច្បាស់ ពីកាតព្វកិច្ចក្នុងកិច្ចសន្យា ដែលតំរូវអោយគោរពតាមច្បាប់ និងគោលការណ៍ដែលមានចែងពីការគោរពពត៌មានឯកជន របស់អតិថិជន ការហាមឃាត់ផ្តល់ពត៌មានឯកជនទៅតតិយជន និងការទទួលខុសត្រូវក្នុង កិច្ចសន្យា ដែលសរសេរជាលាយលក្ខណ៍អក្សរ រឺដោយសារអេឡិចត្រូនិច របស់ធនាគារគូកមីន ។ ធនាគារគូកមីន នឹងផ្សាយចេញកិច្ចសន្យាថ្មី រឺប្រាប់ពីការផ្លាស់ប្តូរទៅអ្នកលក់ តាមរយ:ការចុះ ផ្សាយតាមក្នុងសេចក្តីជូនដំណឹង នៃគេហទំព័ររបស់ធនាគារ រឺការធ្វើវិសោធនកម្ម រឺការកែតំរូវលើគោលការណ៍ឯកជនរបស់ធនាគារ ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("សិទ្ធិនិងកាតព្ចកិច្ច និងវិធីពង្រឹងសិទ្ធិនិងកាតព្វកិច្ច")
        ])
      ]),
      _c("p", [
        _vm._v(
          "លោកអ្នកមានសិទ្ធិទាមទារការប្រើប្រាស់ពត៌មានឯកជន ដែលកាន់កាប់ដោយធនាគារគូកមីន រួមបញ្ចូលទាំងពត៌មានផ្ទាល់ខ្លួនរបស់លោកអ្នកផ្ទាល់ រឺរបស់កូនដែលមានអាយុក្រោម ១៨ឆ្នាំ (ក្នុងករណីដែលលោកអ្នកជាអណាព្យាបាលស្របច្បាប់និងទទួលស្គាល់ដោយអាជ្ញាធរ) ។"
        )
      ]),
      _c("p", [
        _vm._v(
          "លោកអ្នកអាចទាមទារអោយធនាគារគូកមីន កែតំរូវ រឺលប់ពត៌មានឯកជនរបស់លោកអ្នក ដែលលោកអ្នកបានឃើញ ក្នុងករណីដែលពត៌មាននោះ ខុសពីការពិត រឺក៏មិនត្រូវបានបញ្ជាក់ ច្បាស់លាស់ ប្រសិនពត៌មានមិនត្រូវបានប្រមូល រឺគ្រប់គ្រងដោយច្បាប់ រឺបទបញ្ញត្តិណាមួយ ។"
        )
      ]),
      _c("p", [
        _vm._v(
          " លោកអ្នក អាចទាមទារអោយធនាគារគូកមីន ពន្យាការប្រើប្រាស់ពត៌មានរបស់លោកអ្នក ហើយធនាគារគូក អាចបដិសេដការទាមទារការពន្យាពេល នៃការប្រើប្រាស់ពត៌មានបាន ដោយ ត្រូវផ្តល់មូលហេតុនៃការបដិសេធដូចតទៅ: "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "មានបទបញ្ញត្តិពិសេសចែងក្នុងច្បាប់ រឺ ករណីធនាគារគូកមីន មិនអាចអោយបាន ដោយសារធនាគារ ប្រើប្រាស់ពត៌មានរបស់លោកអ្នកដើម្បីបំពេញការកាតព្វកិច្ច ដែលតំរូវអោយអនុវត្តតាមច្បាប់ រឺបទបញ្ញត្តិណាមួយ ។"
          )
        ]),
        _c("li", [
          _vm._v(
            "ការពន្យានៃការប្រើប្រាស់ពត៌មាន ដោយសារការបង្កគ្រោះថ្នាក់ដល់ជីវិត រឺរាង្គកាយ របស់ នរណាម្នាក់ រឺរើសអើងទ្រព្យសម្បត្តិ ដែលមិនសមហេតុផល រឺប៉ះពាល់ដល់ផលប្រយោជន៍ របស់អ្នកដទៃ ។"
          )
        ]),
        _c("li", [
          _vm._v(
            "ការកកខានមិនបានប្រើប្រាស់ពត៌មានឯកជន របស់អតិថិជន ប៉ះពាល់ដល់លទ្ធផលរបស់ធនាគារជាមួយអតិថិជន រួមបញ្ចូលការកកខានមិនផ្តល់កិច្ចសន្យាជាមួយអតិថិជន ក្នុងករណីដែលលោកអ្នកមិនបានបញ្ជាក់ពីគោលបំណងនៃការបញ្ចប់កិច្ចសន្យា ។"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("ពត៌មានឯកជនដែលត្រូវការ")])
      ]),
      _c("p", [
        _vm._v(
          "ធនាគារគូកមីនកម្ពុជា ប្រមូលពត៌មានចាំបាច់ និង ពត៌មានតាមការស្ម័គ្រចិត្ត ដែលត្រូវការដើម្បីបង្កើត រក្សាទុក ប្រតិបត្តិ គ្រប់គ្រងប្រតិបត្តិការហិរញ្ញវត្ថុ និងដាក់បំរើផលិតផល និងសេវាកម្ម ដែលពត៌មាន ទាំងនោះមានដូចខាងក្រោម :"
        )
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("ពត៌មានចាំបាច់:")]),
        _c("dd", [
          _vm._v(
            " - ពត៌មានកំណត់អត្តសញ្ញាណរបស់បុគ្គល : មានដូចជា ឈ្មោះ លេខអត្តសញ្ញាណ ប័ណ្ណ សញ្ជាតិ ពត៌មានទំនាក់ទំនង មានដូចជា អស័យដ្ឋាន អ៊ីម៉ែល និងលេខទូរស័ព្ទ ជាដើម ។ "
          ),
          _c("br"),
          _vm._v(
            "- ពត៌មានពីប្រតិបត្តិការហិរញ្ញវត្ថុ : ប្រភេទផលិតផល លក្ខខណ្ឌប្រតិបត្តិការ (អត្រាការប្រាក់ កាលបរិច្ឆេទផុតកំណត់ ប័ណ្ណដាក់បញ្ចាំ...។ល។ "
          ),
          _c("br"),
          _vm._v(
            "- ពត៌មានដទៃ ដែលប្រើប្រាស់សំរាប់យកមកប្រឹក្សា ក្នុងបំណងបង្កើត រក្សាទុក ប្រតិបត្តិ និងគ្រប់គ្រងប្រតិបត្តិការហិរញ្ញវត្ថុ ។ "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [
          _vm._v("ពត៌មានអោយតាមការស្ម័គ្រចិត្ត (Optional Information):")
        ]),
        _c("dd", [
          _vm._v(
            " - ពត៌មានដែលបង្ហាញក្នុងពាក្យសុំ លើកលែងពត៌មានកំណត់អត្តសញ្ញាណរបស់បុគ្គល ដែលលោកអ្នកអោយ ។ "
          ),
          _c("br"),
          _vm._v(
            "- ស្ថានភាពគ្រូសារ រឺផ្ទះ រយ:ពេលរស់នៅ សមាជិកគ្រួសារ និងស្ថានភាពរៀបការ "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("ពត៌មានត្រូវប្រមូលសំរាប់ធនាគារអេឡិចត្រូនិច")]),
        _c("dd", [
          _vm._v(
            " - សំរាប់តាមដានប្រតិបត្តិការធនាគារអេឡិចត្រូនិច : ឈ្មោះIDអ្នកប្រើប្រាស់ លេខ IP address, លេខ HDD, Max address ។ "
          ),
          _c("br"),
          _vm._v(
            "- ទិន្នន័យសំរាប់ធ្វើសិ្ថតិ ដើម្បីរៀបចំគោលការណ៏សុវត្ថិភាព: ការរៀបចំFirewall ជាលក្ខណ:បុគ្គល, ប្រភេទOS, Security Patches, ការរៀបចំFirewall, រៀបចំ Remote access, browser version, ប្រភេទKeyboard ។ "
          ),
          _c("br"),
          _vm._v(
            "* ធនាគារគូកមីន មិនប្រមូលពត៌មានដែលរសើប រឺពត៌មានប៉ះពាល់ដល់ឯកជនភាពរបស់លោកអ្នក ទេ ។ ក្នុងករណីចាំបាច់ ដែលតំរូវអោយយើងប្រមូលនិងប្រើប្រាស់ពត៌មានទាំងនោះ ធនាគារនឹង ប្រមូល ប៉ុន្តែត្រូវមានការយល់ព្រមបន្ថែមពីអតិថិជន ។ "
          )
        ])
      ]),
      _c("dl", { staticClass: "explain" }, [
        _c("dt", [_vm._v("វិធីសាស្រ្តប្រមូលពត៌មាន")]),
        _c("dd", [
          _vm._v(" - ប្រមូលដោយផ្ទាល់ពីអតិថិជនដែលមកធនាគារ "),
          _c("br"),
          _vm._v(
            "- ប្រមូលពីគេហទំព័រ ពីពាក្យសុំ រឺតាមរយ:លេខទូរសារ សារសំនួរចំលើយ អ៊ីម៉ែល ពីពត៌មានភ្ជាប់មកព្រឹត្តការណ៍ប្រម៉ូសិន តាមពាក្យស្នើសុំដឹជញ្ជូនដល់ផ្ទះ ជាដើម ។ "
          ),
          _c("br"),
          _vm._v("- ឧបករណ៍ប្រមូលពត៌មានសំរាប់ពត៌មានដែលល្បី ៗ ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [_vm._v("ការប្រើប្រាស់ Cookie")])
      ]),
      _c("p", [
        _vm._v(
          'ធនាគារគូកមីន ពិតជាប្រើប្រាស់បច្ចេកវិជ្ជា ដើម្បីផ្តល់ជូនអោយលោកអ្នកមានអារម្មណ៍ស្រួល សុវត្តិភាព និងសំរាប់ផ្តល់សេវាបន្ទាប់បន្សំ ។ ឧទាហរណ៍នៃបច្ចេកទេសដែលធនាគារគូកមីន ប្រើប្រាស់ ដូចជា "Cookie" ។ Cookie គឺជាឧបករណ៍មួយ នៃទិន្នន័យ ដែលគេហទំព័រ អាចផ្ញើទៅ Browser របស់លោកអ្នក បន្ទាប់មកដ៏រក្សាទុកក្នុងប្រព័ន្ធរបស់លោកអ្នក ។ បច្ចុប្បន្ននេះ ធនាគារ គូកមីន ប្រើប្រាស់ Cookie ដើម្បីបំពេញការតំរូវ នៃប្រព័ន្ធសុវត្ថិភាព ក្នុងអំឡុងពេល លោកអ្នក កំពុង ប្រើប្រាស់ គេហទំព័ររបស់ធនាគារ ។ នៅពេល អ្នកប្រើប្រាស់ ភ្ជាប់គេហទំព័រ កុំព្យូទ័រដែលផ្តល់សេវា អាចអាន ពីមាតិកានៃCookie ក្នុង Browswer របស់អ្នកប្រើប្រាស់ និងផ្តល់សេវាដែលបានស្វែងរក ពត៌មានបន្ថែម ដែលមានក្នុ កុំព្យួទ័រ ដោយមិនចាំបាច់បញ្ចូលID រឺក៏បារម្ភពីការភ្ជាប់ប្រព័ន្ធ ។'
        )
      ]),
      _c("p", [
        _vm._v(
          "ប្រសិនបើ លោកអ្នក គិតថា វាមិនមានសារ:សំខាន់ ចំពោះលោកអ្នកធ្វើប្រតិបត្តិការ ជាមួយធនាគារ គូកមីន លោកអ្នកមិនចាំបាច់អោយ browser របស់លោកអ្នកទទួលយក Cookie ទេ។ លោកអ្នក អាច យក Browser ទៅប្រាប់ដំណឹង នៅពេលលោកអ្នក ទទួលបានCookie ដែលអាចអោយ លោក អ្នក មានឪកាសសំរេច ថាគួរទទួល រឺមិនទទួល ។ មានពត៌មានជាច្រើន នៅលើប្រព័ន្ធអ៊ិនធើណេត ដែល ភ្ជាប់ជាមួយ Cookie ។ សូមកត់ចំណាំ ពត៌មានមួយចំនួន និងសេវាដែលមិនមានផ្តល់ជូន ប្រសិន លោកអ្នក មិនអោយ Browswer ដំណើរការទទួលCookie ។"
        )
      ]),
      _c("p", [
        _vm._v(
          "សូមចងចាំថា នៅពេលគេហទំព័ររបស់ធនាគារគូកមីន ភ្ជាប់ជាមួយបណ្តាញគេហទំព័រដទៃទៀត ធនាគារគូកមីន មិនទទួលខុសត្រូវ លើការអនុវត្តការរក្សាការសំងាត់ឯកជននៃគេហទំព័រទាំងនោះទេ និង/រឺ មិនទទួលខុសត្រូវ ចំពោះពត៌មាន ដែលបានផ្សាយ នៅលើគេហទំព័រទាំងនោះដែរ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ការលប់បំបាត់ពត៌មានឯកជន")
        ])
      ]),
      _c("p", [
        _vm._v(
          " ក្នុងករណី រយ:ពេលនៃការរក្សាទុកពត៌មានឯកជនរបស់អតិថិជនផុតកំណត់ ធនាគារគូកមីន នឹង លប់បំបាត់ ពត៌មានឯកជន ក្នុងរយ:ពេលប្រាំថ្ងៃនៃថ្ងៃធ្វើការ នៅពេលដែលពត៌មានទាំងនោះ មិនត្រូវ បានគេ ប្រើប្រាស់ក្នុងគោលបំណងណាមួយទៀត ដូចជា ផុតកំណត់នៃរយ:ពេលរក្សាទុកពត៌មាន បញ្ចប់កាតព្វកិច្ច ប្រើប្រាស់ពត៌មានឯកជន ការឈប់ប្រើប្រាស់សេវាកម្មដែលពាក់ព័ន្ធ រឺការបិទ អាជីវកម្ម ប្រសិនបើ : "
        ),
        _c("br"),
        _c("br")
      ]),
      _c("ul", { staticClass: "list txt" }, [
        _c("li", [
          _vm._v(
            "ភ្នាក់ងារផ្តល់ពត៌មានឥណទាន ឬការិយាល័យឥណទានរក្សាទុកពត៌មានឯកជនរបស់អតិថិជន (អនុញ្ញាតអោយតែក្នុងអំឡុងពេលរក្សាទុក ) សំរាប់គោលបំណងប្រើប្រាស់ ការគ្រប់គ្រងនៃ មណ្ឌលពត៌មានឥណទាន រឺការវាយតំលៃឥណទាន ។"
          )
        ]),
        _c("li", [
          _vm._v(
            "ការិយាល័យប្រព័ន្ធឥណទាន ឧទាហរណ៍ការរក្សាទុកនៃពត៌មានឯកជន សំរាប់អំឡុងពេលនៃ ប្រសិទិ្ធភាពនៃការអនុវត្តកាតព្វកិច្ចស៊ីវិល ឧក្រិដ្ឋកម្ម រឺសំរាប់រយ:ពេលកំណត់ក្នុងលក្ខន្តិក: រឺការកាន់កាប់ពត៌មានឥណទានបុគ្គល សំរាប់ជាភស្ភុតាងក្នុងការដោះស្រាយជម្លោះ"
          )
        ]),
        _c("li", [
          _vm._v(
            "ក្នុងករណី ធនាគារ មានកាតព្វកិច្ចរក្សាទុកពត៌មានឯកជនរបស់អតិថិជន ក្នុងការអនុវត្តច្បាប់ ណាមួយ ។"
          )
        ]),
        _c("li", [_vm._v("និងមូលហេតុសមហេតុផលដទៃទៀត")])
      ]),
      _c("p", [
        _c("br"),
        _vm._v(
          "ឯកសារដែលមានពត៌មានឯកជនបោះពុម្ភរួច និងមិនត្រូវបានរួមបញ្ចូលគ្នា រឺត្រូវបានបំផ្លាញ ដោយភ្លើង រឺឯកសារនៃពត៌មានឯកជនទំរង់ជាអេឡិចត្រូនិច គួរលប់បំបាត់ចោល ដើម្បីមិន អាចអោយយកមកប្រើប្រាស់វិញបាន ។ "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_title" }, [
      _c("h2", { staticClass: "h_title2" }, [
        _vm._v("វិធីសាស្រ្តការពារពត៌មានឯកជនរបស់អតិថិជន")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("ការលាក់ការសំងាត់នៃពត៌មានឯកជន")]),
      _c("dd", [
        _vm._v(
          "ពត៌មានឯកជនរបស់លោកអ្នក និងលេខសំងាត់ត្រូវបានប្រើប្រាស់ដោយលោកអ្នកតែម្នាក់ គត់ ដោយសារ តែវាត្រូវ បានរក្សាទុកនិងគ្រប់គ្រងដោយប្រព័ន្ធលាក់ទុកពត៌មាន (Encryption) ។ ឯកសារនិងទិន្នន័យត្រូវបញ្ជូនមក និងផ្ទុកទិន្នន័យដែលចាំបាច់ ត្រូវបានរក្សាទុក ក្នុងវិធីសាស្រ្តសុវត្ថិភាពដាច់ដោយឡែកពីគ្នា រួមបញ្ចូលទាំងក្នុងប្រព័ន្ធ លាក់ទុក (Encryption) រឺឯកសារចាក់ទុក(File Locking) ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [_vm._v("វិធីសាស្រ្តបច្ចេកទេសប្រយុទ្ធប្រឆាំងនឹងការHacking")]),
      _c("dd", [
        _vm._v(
          "ក្តារVirtual របស់ធនាគារ រក្សាទុកតំលៃដែលលោកអ្នកដាក់បញ្ចូល ។ ការការពារការលេច ចេញ រឺការលប់បំបាត់នៃពត៌មានឯកជន ដែលបានដាក់ ដោយពួកHacking រឺដោយវីរុស របស់កុំព្យួទ័រ ។ ធនាគារគូកមីន សូមណែនាំអោយលោកអ្នក បញ្ចូលកម្មវិធីសុវត្ថិភាព និងធ្វើបច្ចុប្បន្នភាពកម្មវិធី ព្រមទាំងត្រួតពិនិត្យតាមគ្រា នៅពេលដាក់ប្រព័ន្ធអោយប្រើប្រាស់ តាមផ្នែក និងធ្វើការត្រួតពិនិត្យបច្ចេកទេស និងភាពខាងក្រៅ និងការបង្ខាំងមិនអោយប្រើ ប្រាស់ពីខាងក្រៅ ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "explain" }, [
      _c("dt", [
        _vm._v("ប្រព័ន្ធគ្រប់គ្រងទិន្នន័យពត៌មានឯកជនដែលត្រូវកំនត់អោយប្រើប្រាស់")
      ]),
      _c("dd", [
        _vm._v(
          "ធនាគារគូកមីន យកវិធីសាស្រ្តតំរូវអោយកំណត់ការប្រើប្រាស់ពត៌មានឯកជន ដោយមាន ការយល់ព្រម ការបញ្ជាក់ រឺការបញ្ចប់នៃការប្រើប្រាស់ប្រព័ន្ធទិន្នន័យ ដែលមានពត៌មាន ឯកជន ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ការកែប្រែគោលនយោបាយឯកជន")
        ])
      ]),
      _c("p", [
        _vm._v(
          "ក្នុងករណី មានការកែប្រែលើគោលនយោបាយឯកជន កាលបរិច្ឆេទធ្វើវិសោធនកម្ម និង ចូលជា ធរមាន ព្រមទាំងសេចក្តីលំអិតនៃការផ្លាស់ប្តូរ ត្រូវបង្ហាញជានិច្ច ។ ការប្រៀបធៀបរវាង គោលនយោបាយចាស់និងថ្មី ត្រូវតែផ្សព្វផ្សាយ ដើម្បីជួយលោកអ្នក អោយយល់ដឹង ពីការផ្លាស់ប្តូរជាលំអិត ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("គួរយល់ដឹងពីការការពារពត៌មានឯកជន")
        ])
      ]),
      _c("p", [
        _vm._v(
          "សូមចងចាំថា ពត៌មានដែលលោកអ្នកផ្តល់ជូនជាអេឡិចត្រូនិចនៅលើសេចក្តីប្រកាសពត៌មាន លើ អ៊ីម៉ែល រឺនៅលើឧបករណ៍នាំសារអេឡិចត្រូនិច ត្រូវបានប្រមូល ហើយអ្នកដទៃអាចប្រើប្រាស់បាន ។ ហេតុនេះហើយ ក្នុងករណីខ្លះ លោកអ្នក អាចទទួលបានសារអេឡិចត្រូនិច ដែលលោកអ្នកមិនចង់ បាន ។"
        )
      ]),
      _c("p", [
        _vm._v(
          "លោកអ្នក ទទួលខុសត្រូវលើការរក្សាទុកលេខ ID របស់លោកអ្នក លេខសំងាត់របស់អ្នកប្រើប្រាស់ និងលេខ OTP ដោយប្រុងប្រយ័ត្ន ទន្ទឹមនឹងនេះ លោកអ្នក គួរប្រុងប្រយ័ត្ន នៅពេលចូលប្រើប្រាស់ ប្រព័ន្ធធនាគារអេឡិចត្រូនិច ។"
        )
      ]),
      _c("p", [
        _vm._v(
          "ធនាគារគូកមីន មិនទទួលខុសត្រូវ លើការបាត់បង់ រឺការខូចខាតណាមួយ ដែលកើតឡើងដោយ ការធ្វេសប្រហែស និងការមិនថែរក្សាពត៌មានឯកជនរបស់លោកអ្នកដោយផ្ទាល់ទេ ។"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ការបង្ការការរំលោភសិទ្ធិ")
        ])
      ]),
      _c("p", [
        _vm._v(
          "សូមទំនាក់ទំនង ផ្នែកសេវាបំរើអតិថិជន រឺស្ថាប័នខាងក្រោមដើម្បីសុំពត៌មានបន្ថែម :"
        )
      ]),
      _c("p", [
        _c("strong", { staticClass: "fc_point1" }, [
          _vm._v("ធនាគារគូកមីន កម្ពុជា ភីអិលស៊ី (855-23-999-300 ~ 308)")
        ]),
        _c("br")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("div", { staticClass: "wrap_title" }, [
        _c("h2", { staticClass: "h_title2" }, [
          _vm._v("ប្រធានគ្រប់គ្រង ការពារពត៌មានឯកជន")
        ])
      ]),
      _c("dl", { staticClass: "addr" }, [
        _c("dt", [
          _c("strong", { staticClass: "fc_point1" }, [
            _vm._v("លោក Kim Hyeun Jong, ប្រធានធនាគារគូកមីន កម្ពុជា ភីអិលស៊ី")
          ])
        ]),
        _c("dd", [
          _c("span", [
            _vm._v("អាស័យដ្ឋាន អគារ ៥៥ សង្កាត់បឹងរាំង ដូនពេញ ភ្នំពេញ កម្ពុជា")
          ])
        ]),
        _c("dd", [_vm._v("លេខទំនាក់ទំនង 855-23-999-300 ~ 308")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap_cont type2" }, [
      _c("p", [_vm._v("ធនាគារគូកមីនកម្ពុជាភីអិលស៊ី គោលនយោបាយឯកជន: Ver 2.0")]),
      _c("p", [
        _vm._v("កាលបរិច្ឆេទមានប្រសិទ្ធិភាព នៃគោលនយោបាយឯកជន : 30.06.2020")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }